import React, { useState, useEffect } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { Card, CardBody, CardTitle, Label, Input, Breadcrumb, BreadcrumbItem, Row, Col, Button } from 'reactstrap';
import ListadoV2 from '../../components/lists/ListadoV2';

//Componentes
import Loading from '../../components/modales/loadingModal';
import DownloadTableButton from '../../components/buttons/downloadTableButton';
import LoadingModalTransparent from '../../components/modales/loadingModalTransparent';

//Redux
import { connect } from 'react-redux';
//GCP Functions
import { functionsHttpsCallable } from '../../utils/FirebaseStorage/firebase';

//API Calls
const listadoReportes = functionsHttpsCallable('ape_listadoNomina');
const cambioEstado = functionsHttpsCallable('ape_cambioEstadoReporteNomina');
const exportarReporte = functionsHttpsCallable('ape_exportarInformeNomina');

const mapStateToProps = state => ({
    usuarioActivo: state
})

//Toast
const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

const GestorNomina = (props) => {
    let todayDate = new Date(Date.now())
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [startDate, setStartDate] = useState(new Date(todayDate.getFullYear(), todayDate.getMonth(), 1))
    const [endDate, setEndDate] = useState(new Date(todayDate.getFullYear(), todayDate.getMonth() + 1, 1))
    const [lista, setLista] = useState([]);
    const [seleccionados, setSeleccionados] = useState([]);
    const [modalTransaction, setModalTransaction] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getDataSolicitudes()
        document.title = "Reporte a nómina";
    }, [])
    const getDataSolicitudes = async () => {
        setModalTransaction(true);
        try {
            let body = {
                "fechaInicio": startDate,
                "fechaFin": endDate
            }
            let dataSolicitudes = await listadoReportes(body)
            setLista(dataSolicitudes.data.data)
            setLoading(false)
        }
        catch (e) {
            console.log('error', e)
        }
        setModalTransaction(false);
    }

    const handlerCambioEstado = async (estado) => {
        setModalTransaction(true);
        if (seleccionados.length === 0) {
            toastError('No hay reportes seleccionados');
        }
        else {
            const body = {
                reportes: seleccionados,
                "estado": estado
            };
            await cambioEstado(body);
            toastSuccess('Aprobación exitosa!');
        }
        setModalTransaction(false);
    }

    const downloadInforme = async () => {
        setModalTransaction(true);
        const bodyExp = {
            "fechaInicio": startDate,
                "fechaFin": endDate
        }
        setLoading(true);
        try{
            const downloadLink = await exportarReporte(bodyExp);
            let downloadWindow = window.open(downloadLink.data.data, "_blank", "noopener,noreferrer")
            if (downloadWindow) downloadWindow.opener = null
            toastSuccess('Descarga exitosa');
            setLoading(false);
        }
        catch (error) {
            toastError(`Error ${error.message ?? ''}`);
            setLoading(false);
        }
        setModalTransaction(false);
    }

    const handleCheck = ({ value, field }) =>{
        if (value) {
            const index = seleccionados.findIndex(i => i === field);
            if (index < 0) seleccionados.push(field);
        }
        else {
            const index = seleccionados.findIndex(i => i === field);
            if (index >= 0) seleccionados.splice(index, 1);
        }
    }

    const renderListaSolicitudes = () => {
        return (
            <ListadoV2
                listaSolicitudes={lista}
                handleCheck={(e) => { handleCheck(e) }}
            />
        )

    }

    return (loading ?
        <div className={"loading-area"}>
            <Loading />
        </div> :
        <>
            <Toaster />
            <LoadingModalTransparent isOpen={modalTransaction} />
            <Breadcrumb>
                <BreadcrumbItem className='breadcum-display-content' active>
                    Resumen de Reportes
                    <div>
                        <DownloadTableButton
                            onClick={() => {
                                downloadInforme();
                            }}
                        /></div>
                </BreadcrumbItem>
            </Breadcrumb>
            <Card>
                <CardBody>
                    <CardTitle tag="h5">Solicitudes</CardTitle>
                </CardBody>
                <CardBody>
                    <Row>
                        <Col lg='4' md='4' xs="4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                            <Label for="exampleSelect">Fecha de Inicio</Label>
                            <Input
                                id="startDate"
                                name="datetime"
                                value={startDate ? startDate.toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                                onChange={(e) => {
                                    try {
                                        if (!isNaN(new Date(e.target.value.toUpperCase()))) setStartDate(new Date(e.target.value))
                                    }
                                    catch (error) {
                                        console.log(error)
                                    }
                                }}

                                type="date"
                            />
                        </Col>
                        <Col lg='4' md='4' xs="4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                            <Label for="exampleSelect">Fecha de Fin</Label>
                            <Input
                                id="startDate"
                                name="datetime"
                                value={endDate ? endDate.toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                                onChange={(e) => {
                                    try {
                                        if (!isNaN(new Date(e.target.value.toUpperCase()))) setEndDate(new Date(e.target.value))
                                    }
                                    catch (error) {
                                        console.log(error)
                                    }
                                }}

                                type="date"
                            />
                        </Col>
                        <Col lg='2' md='4' xs="4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-end' }}>
                            <Button variant="contained" color="primary" onClick={() => getDataSolicitudes()} disabled={false}>
                                Buscar
                            </Button>
                        </Col>
                    </Row>
                    <br/>
                    {renderListaSolicitudes()}
                    <br/>
                    <div className={"breadcum-header-buttons"}>
                    <div className={"button-bar-container"}>
                        <div className={"button-bar-button"}>
                            <Button variant="contained" color="secondary" onClick={() => handlerCambioEstado('RECHAZADO')} disabled={seleccionados.length > 0}>
                                Cancelar
                                        </Button>
                        </div>
                        <div className={"button-bar-button"}>
                                <Button variant="contained" color="primary" onClick={() => handlerCambioEstado('APROBADO')} disabled={seleccionados.length > 0}>
                                Aceptar
                        </Button>
                        </div>
                    </div>
                </div>
                </CardBody>
            </Card>
        </>
    )
}

export default withAuthenticationRequired(connect(mapStateToProps)(GestorNomina), {
    onRedirecting: () => <Loading />,
});